module.exports = __webpack_public_path__ + "img/img-121.6a4a94d7.png";